// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__10xlW","label":"Category_label__2tcXT","content":"Category_content__xR4-u","header":"Category_header__3Ujgb","location":"Category_location__CVFxx"};